<template>
  <div v-if="!selecionouComplemento && complemento">
    <div class="complemento-container" v-for="registro in complemento">
      <RadioButton
        v-if="complemento.length > 1"
        :seleciona="seleciona"
        :classe="classe"
        :imposto="registro"
        :loading="loading"
      />
      <Registro :paddingSemCheckBox="complemento.length == 1">
        <Cabecalho :titulo="registro.label" :aliquota="registro.aliquota" />
        <div v-if="registro.label" class="separador" />

        <Ncm :ncm="registro.ncm" />
        <div v-if="registro.ncm" class="separador" />

        <Descricao
          v-if="!!registro.descricao"
          :titulo="'Descrição'"
          :descricao="registro.descricao"
        />
        <div v-if="registro.descricao && registro.vigencia_fim" class="separador" />
        <Cabecalho
          v-if="!!registro.vigencia_fim"
          :tipo="'data'"
          :titulo="'Vigência'"
          :aliquota="registro.vigencia_fim"
        />
        <GrupoNotificacao v-if="registro" :registro="registro" />
        <div v-if="registro.base_legal" class="separador" />
        <BaseLegal :base_legal="registro.base_legal" />
      </Registro>
    </div>
  </div>

  <div :key="getRenderKey" v-else-if="complemento">
    <div class="complemento-container">
      <EditButton
        v-if="complemento.length != 1"
        :classe="classe"
        :edita="edita"
        :loading="loading"
      />
      <Registro :paddingSemCheckBox="complemento.length == 1">
        <Cabecalho
          :titulo="complementoSelecionado.label"
          :aliquota="complementoSelecionado.aliquota"
        />
        <div v-if="complementoSelecionado.label" class="separador" />

        <Ncm :ncm="complementoSelecionado.ncm" />
        <div v-if="complementoSelecionado.ncm" class="separador" />

        <Descricao
          v-if="!!complementoSelecionado.descricao"
          :titulo="'Descrição'"
          :descricao="complementoSelecionado.descricao"
        />
        <div
          v-if="complementoSelecionado.descricao && complementoSelecionado.vigencia_fim"
          class="separador"
        />
        <Cabecalho
          v-if="!!complementoSelecionado.vigencia_fim"
          :tipo="'data'"
          :titulo="'Vigência'"
          :aliquota="complementoSelecionado.vigencia_fim"
        />
        <GrupoNotificacao v-if="complementoSelecionado" :registro="complementoSelecionado" />
        <div v-if="complementoSelecionado.base_legal" class="separador" />
        <BaseLegal :base_legal="complementoSelecionado.base_legal" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro";

import { mapGetters } from "vuex";

export default {
  name: "RegistrosComplemento",

  props: {
    classe: String,
    complemento: Object | Array,
    loading: Boolean,
    seleciona: Function,
    complementoSelecionado: Object,
    selecionouComplemento: Boolean,
    edita: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Ncm,
    Notificacao,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },

  created() {
    //se tiver apenas um resultado, seleciona o mesmo.
    if (this.complemento && this.complemento.length == 1) {
      this.seleciona(this.complemento[0]);
    }
  },

  mounted() {},

  computed: {
    ...mapGetters("reRender", ["getRenderKey"])
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.complemento-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
